import { resolveBrandFromHostname } from "./brandResolver";

let cachedBrand = null;

export function getActiveBrand() {
    if (!cachedBrand) {
        cachedBrand = resolveBrandFromHostname(window.location.hostname);
    }
    return cachedBrand;
}
